import styled from 'styled-components';
import Colors from '../../makealist/styles/colors';

const StyledContainer = styled.div`
    background: #2c2c2c;
    text-align: center;
    position: fixed;
    margin: 0;
    top: 0;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: 80px;
`;

const StyledButton = styled.button`
    height: 50px;
    width: 200px;
    background: transparent;
    border: none;
    color: ${Colors.goldLight};
    outline: none;
    cursor: pointer;
`;

export {
  StyledContainer,
  StyledButton,
};
